import React, { useEffect, useState } from "react";
import { useAlertStore } from 'src/hooks/Alert';
import { Pagination } from 'src/reusable/global';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import Helper from 'src/support/Helper';
import StockAlertSearchBox from './StockAlertSearchBox';
import Product from "@system/config/product";
import { __remove, __set } from 'src/store/axios_indicator';

const StockAlertListingTable = (props) => {
    const listObjModel = {
        pageCount: 0,
        page: 1,
        limit: 20,
    }
    const [__check] = useAxiosIndicatorCheck();
    const [isDeletedAlert, setIsDeletedAlert] = useState(false);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [{ StockAlertListingByType }, { get_stock_alert_listing }, { delete_stock_alert }] = useAlertStore();
    const [{ filter_list }, { }, { }] = useFilterSelectionStore();
    const [AlertFirstServerCall] = useReduxState(false, 'setAlertFirstServerCall');
    const [listObj, setListObj] = useState(listObjModel);

    useEffect(() => {
        setListObj({ ...listObjModel })
    }, [filter_list]);

    useEffect(() => {
        fetchAPiCall();
    }, [listObj]);

    useEffect(() => {
        if (!monitorFunctionCall && AlertFirstServerCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [__check('STOCK_ALERT_API_CALL').status, AlertFirstServerCall])

    const handlePageClick = async (data) => {
        setListObj({ ...listObj, page: data.selected + 1})
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, page: 1, limit: event.target.value })
    };

    const fetchAPiCall = async () => {
        let params = {
            "pageNumber": listObj.page,
            "pageSize": listObj.limit,
        }
        if (filter_list.length > 0) {
            params[filter_list[0].key] = filter_list[0].searchKeyword
        }
        await get_stock_alert_listing(params)
    };

    const deleteAlert = async (v) => {
        __set('STOCK_ALERT_API_CALL');
        let res = await delete_stock_alert(v.stockAlertId)
        __remove('STOCK_ALERT_API_CALL');
        if (res.isSuccessFull) {
            setIsDeletedAlert(true)
            const remainingRecords = StockAlertListingByType.totalCount - 1;
            const maxRecordsForCurrentPage = listObj.limit * listObj.page;
            let newpage = listObj.page;
            if (remainingRecords > 0 && remainingRecords < maxRecordsForCurrentPage) {
                newpage = Math.max(1, Math.ceil(remainingRecords / listObj.limit));
                setListObj({ ...listObj, page: newpage })
            }
            fetchAPiCall()
        }
    }

    return (
        <>
            <StockAlertSearchBox />
            {isDeletedAlert &&
                <div className='py-3 alert alert-info'>
                    <span className="w-100" >
                        Your alert has been deleted
                    </span>
                    <button type="button" className="close" aria-label="Close" onClick={() => setIsDeletedAlert(false)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

            }
            {(__check('STOCK_ALERT_API_CALL').status || (StockAlertListingByType.stockAlertItems &&
                Object.entries(StockAlertListingByType.stockAlertItems).length > 0)) &&
                <div className='position-relative'>
                    <div>
                        {__check(['STOCK_ALERT_API_CALL'], { overlay: true }).render}
                    </div>

                    <div className="table-container table-responsive m-b-30">
                        <table className="bs5 table table-bordered">
                            <thead>
                                <tr className="align-middle">
                                    <th>
                                        Customer Part Number
                                    </th>
                                    <th>Manufacturing Part Number
                                    </th>
                                    <th>Manufacturer
                                    </th>
                                    <th>Stock Alert</th>
                                </tr>
                            </thead>
                            {StockAlertListingByType.stockAlertItems && Object.entries(StockAlertListingByType.stockAlertItems).length > 0 &&
                                <tbody>
                                    {StockAlertListingByType.stockAlertItems.map((v, i) => (
                                        <React.Fragment key={i}>
                                            <tr>
                                                <td>{v.customerPartNumber}</td>
                                                <td>
                                                    {v.itemNumber ?
                                                        <a href={Product.getProductDetailPageRouteURLWithCustomParameter(v) + '?ItemNumber=' + v.itemNumber}
                                                            target="_blank"
                                                            className="text-blue2 d-block font-bold" >{v.erpMfrPartNumber}</a>
                                                        :
                                                        <div>{v.erpMfrPartNumber}</div>
                                                    }
                                                </td>
                                                <td>{v.manufacturerName}</td>
                                                <td>
                                                    <span className='cursor-pointer' onClick={() => { deleteAlert(v) }}>Active <i
                                                        className="fa fa-trash me-3 text-black px-2" /></span>
                                                </td>

                                            </tr>
                                        </React.Fragment>
                                    ))
                                    }
                                </tbody>
                            }
                        </table>
                    </div>
                    <Pagination pageCount={Math.ceil(StockAlertListingByType.totalCount / listObj.limit)} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                    <div className="pagination-right"><span>Displaying <b>5</b> of <b>22</b> Items</span></div>
                </div>
            }
            {!__check('STOCK_ALERT_API_CALL').status && StockAlertListingByType.totalCount === 0 &&
                <div className='py-3 alert alert-info text-center'>
                    <span className="text-center w-100">
                        No Alerts Found
                    </span>
                </div>
            }
        </>
    );
}

export default StockAlertListingTable;